import { UPDATE_GROUPS } from '../constants';

const DEFAULT_STATE = {
  groups: {},
};

const GroupsReducer = (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_GROUPS:
      payload.forEach((group) => (state.groups[group.id] = group));
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default GroupsReducer;
